const authConstant = require("./constant");
const axios = require("axios").default;
const _ = require("lodash");

const authCred = async (username, password) => {
  const response = await axios.post(
    authConstant.MAIN_URI,
    {
      name: "generateToken",
      param: {
        usr: username,
        pwd: password,
        ftk: "dummy",
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return _.result(response.data, "response.result.token");
};

export default authCred;
